import { _x } from '@wordpress/i18n'

const ERROR_MESSAGES = {
  AUTH_FAILURE: _x(
    'Please make sure this domain is registered at Google Maps.',
    'location overview error',
    'icf'
  ),
  GENERIC: _x(
    'Please check the configured API key and make sure this domain is registered at Google Maps.',
    'location overview error',
    'icf'
  )
} as const

export default ERROR_MESSAGES
